import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme:Theme) => ({
    select:{
        width:"100%",
    },
    label:{
        fontSize:16,
        paddingTop:22,
    },
    total:{ marginLeft: 15,paddingTop:12,fontWeight:'bold'},
    cellStyle:{marginRight:20}
}));